import React, { useState } from 'react';
import { PatientsTableCardComponent } from '../../../../components/Cards/Patient';
import { withRouter, matchPath, RouteComponentProps } from 'react-router';
import { getPatientSummaries } from '../../../../apis/patient';
import { PatientItem } from '../../../../components/Tables/Patients';
import { getPatentItem } from '../../../../selectors/patient';
import { Filter } from 'react-table';
import { deepCompare } from '../../../../modules/unsw-compare';

export default withRouter((props: RouteComponentProps<{}>) => {
  const [patients, setPatients] = useState<PatientItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useState<Filter[]>([]);
  const [pSearchParams, setPSearchParams] = useState<Filter[]>([]);
  const [hideInactive, setHideInactive] = useState(false);
  const [page, setPage] = useState(0);
  const [previous, setPrevious] = useState<string | undefined>(undefined);
  const [next, setNext] = useState<string | undefined>(undefined);
  const match = matchPath<{ organizationId: string }>(props.location.pathname, {
    path: '/organization/:organizationId',
  });
  return (
    <PatientsTableCardComponent
      patients={patients}
      loading={loading}
      last={!next}
      page={page}
      filtered={searchParams}
      onSearchBarSubmit={values =>
        setSearchParams(
          Object.entries(values).map(([key, value]) => ({ id: key, value })),
        )
      }
      hideInactive={hideInactive}
      setHideInactive={setHideInactive}
      onPageChange={p => (p < page ? setPage(0) : setPage(p))}
      organizationId={match ? match.params.organizationId : undefined}
      onFetchData={async (state: any) => {
        try {
          if (state.page !== 0 && state.page === page) return;
          setLoading(true);

          let path: string | undefined = undefined;

          if (previous && state.page < page) {
            path = previous;
            state.page = 0;
          }

          if (next && state.page > page) {
            path = next;
          }

          if (!deepCompare(pSearchParams, searchParams)) path = undefined;
          const retV = await getPatientSummaries(
            state.pageSize,
            path,
            searchParams,
            hideInactive,
            match ? match.params.organizationId : undefined,
          );
          const { data } = retV;
          // data.map(d => deletePatient(d.id || ""));
          setNext(retV.next);
          setPrevious(retV.previous);

          const items = data.map(patient => getPatentItem(patient));
          setPSearchParams(searchParams);
          setPatients(items);
          setLoading(false);
        } catch (e) {
        } finally {
          setLoading(false);
        }
      }}
    />
  );
});
